module.exports = __webpack_public_path__ + "media/hallBgm.0db53340.mp3";